(function () {
  'use strict';

  var API_NAME = 'PfuDesktopCanvas';
  var LEGACY_STORAGE_KEYS = ['pfuDesktopCanvasBaseline.v1', 'pfuDesktopCanvasBaseline.v2'];
  var MIN_DESKTOP_WIDTH = 992;
  var rafId = 0;
  var legacyBaselinesCleared = false;

  if (window[API_NAME] && window[API_NAME].initialized) {
    window[API_NAME].refresh();
    return;
  }

  function getCanvas() {
    var canvas = document.querySelector('[data-pfu-page-canvas]');

    if (canvas && canvas.classList.contains('pfu-page-canvas--connect')) {
      return null;
    }

    return canvas;
  }

  function getViewportWidth() {
    var root = document.documentElement;
    return Math.round(root.clientWidth || window.innerWidth || 0);
  }

  function clearLegacyBaselines() {
    if (legacyBaselinesCleared) {
      return;
    }

    legacyBaselinesCleared = true;

    try {
      if (!window.sessionStorage) {
        return;
      }

      LEGACY_STORAGE_KEYS.forEach(function (key) {
        window.sessionStorage.removeItem(key);
      });
    } catch (error) {
      return;
    }
  }

  function isFinitePositive(value) {
    return Number.isFinite(value) && value > 0;
  }

  function resetCanvas(canvas) {
    delete canvas.dataset.pfuCanvasMode;
    delete canvas.dataset.pfuCanvasWidth;
    delete canvas.dataset.pfuCanvasZoomRatio;
    canvas.style.removeProperty('--pfu-canvas-width');
    document.documentElement.style.removeProperty('--pfu-canvas-width');
  }

  function getCanvasWidth(canvas) {
    var rect = canvas.getBoundingClientRect ? canvas.getBoundingClientRect() : null;
    var width = rect && rect.width ? rect.width : canvas.clientWidth;
    return Math.round(width || getViewportWidth() || 0);
  }

  function applyCanvas() {
    var canvas = getCanvas();
    var viewportWidth;
    var canvasWidth;

    if (!canvas) {
      document.documentElement.style.removeProperty('--pfu-canvas-width');
      return;
    }

    clearLegacyBaselines();

    viewportWidth = getViewportWidth();
    if (viewportWidth < MIN_DESKTOP_WIDTH) {
      resetCanvas(canvas);
      return;
    }

    canvas.dataset.pfuCanvasMode = 'active';
    delete canvas.dataset.pfuCanvasZoomRatio;
    canvasWidth = getCanvasWidth(canvas);
    canvas.dataset.pfuCanvasWidth = String(canvasWidth);

    if (isFinitePositive(canvasWidth)) {
      canvas.style.setProperty('--pfu-canvas-width', canvasWidth + 'px');
      document.documentElement.style.setProperty('--pfu-canvas-width', canvasWidth + 'px');
    } else {
      canvas.style.removeProperty('--pfu-canvas-width');
      document.documentElement.style.removeProperty('--pfu-canvas-width');
    }
  }

  function requestRefresh() {
    if (rafId) {
      return;
    }

    rafId = window.requestAnimationFrame(function () {
      rafId = 0;
      applyCanvas();
    });
  }

  function refresh() {
    requestRefresh();
  }

  function destroy() {
    var canvas = getCanvas();

    window.removeEventListener('resize', requestRefresh);
    window.removeEventListener('pageshow', requestRefresh);
    document.removeEventListener('shopify:section:load', requestRefresh);

    if (rafId) {
      window.cancelAnimationFrame(rafId);
      rafId = 0;
    }

    if (canvas) {
      resetCanvas(canvas);
    }

    window[API_NAME].initialized = false;
  }

  window[API_NAME] = {
    initialized: true,
    refresh: refresh,
    destroy: destroy
  };

  window.addEventListener('resize', requestRefresh);
  window.addEventListener('pageshow', requestRefresh);
  document.addEventListener('shopify:section:load', requestRefresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestRefresh, { once: true });
  } else {
    requestRefresh();
  }
}());
